export const FETCH_ORDERS_DATA = 'FETCH_ORDERS_DATA'
export const FETCH_ORDERS_DATA_SUCCESS = 'FETCH_ORDERS_DATA_SUCCESS'

export const FETCH_PLAY_CARE_TRANSACTIONS_DATA =
  'FETCH_PLAY_CARE_TRANSACTIONS_DATA'
export const FETCH_PLAY_CARE_TRANSACTIONS_DATA_SUCCESS =
  'FETCH_PLAY_CARE_TRANSACTIONS_DATA_SUCCESS'

export const FETCH_INSTALLMENT_ORDERS_DATA = 'FETCH_INSTALLMENT_ORDERS_DATA'
export const FETCH_INSTALLMENT_ORDERS_DATA_SUCCESS =
  'FETCH_INSTALLMENT_ORDERS_DATA_SUCCESS'
